module.exports = __webpack_public_path__ + "img/designer_intro_icon.d1816832.png";